var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1377 2.19526C15.3981 2.45561 15.3981 2.87772 15.1377 3.13807L8.47108 9.80474C8.21073 10.0651 7.78862 10.0651 7.52827 9.80474L5.52827 7.80474C5.26792 7.54439 5.26792 7.12228 5.52827 6.86193C5.78862 6.60158 6.21073 6.60158 6.47108 6.86193L7.99967 8.39052L14.1949 2.19526C14.4553 1.93491 14.8774 1.93491 15.1377 2.19526Z",
    fill: "#131111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 2.66683C3.1562 2.66683 2.98663 2.73707 2.8616 2.86209C2.73658 2.98712 2.66634 3.15668 2.66634 3.3335V12.6668C2.66634 12.8436 2.73658 13.0132 2.8616 13.1382C2.98663 13.2633 3.1562 13.3335 3.33301 13.3335H12.6663C12.8432 13.3335 13.0127 13.2633 13.1377 13.1382C13.2628 13.0132 13.333 12.8436 13.333 12.6668V8.00016C13.333 7.63197 13.6315 7.3335 13.9997 7.3335C14.3679 7.3335 14.6663 7.63197 14.6663 8.00016V12.6668C14.6663 13.1973 14.4556 13.706 14.0806 14.081C13.7055 14.4561 13.1968 14.6668 12.6663 14.6668H3.33301C2.80257 14.6668 2.29387 14.4561 1.91879 14.081C1.54372 13.706 1.33301 13.1973 1.33301 12.6668V3.3335C1.33301 2.80306 1.54372 2.29436 1.91879 1.91928C2.29387 1.54421 2.80257 1.3335 3.33301 1.3335H10.6663C11.0345 1.3335 11.333 1.63197 11.333 2.00016C11.333 2.36835 11.0345 2.66683 10.6663 2.66683H3.33301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidCheckIcon);
export default __webpack_public_path__ + "static/media/valid-check-icon.af8322c41bd815287e669edaf595d8b0.svg";
export { ForwardRef as ReactComponent };